import type { IStore, IStoreLocation } from '@inter-ikea-kompis/types';

/**
 * This class is used for transforming data from IRW into the format of the Store model.
 */
export default class IowsStoreTransformer {
	/**
	 * Transforms data into format of StoreAvailability model.
	 *
	 * @param data Data to parse.
	 * @returns Parsed data.
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
	public transform(data: any): IStore[] {
		const stores: IStore[] = [];
		if (data.StoreRefList && data.StoreRefList.StoreRef) {
			const items = Array.isArray(data.StoreRefList.StoreRef)
				? data.StoreRefList.StoreRef
				: [data.StoreRefList.StoreRef];
			for (const item of items) {
				stores.push({
					location: this.getLocation(item),
					name: item.StoreName && item.StoreName.$ ? item.StoreName.$ : null,
					id: item.StoreNo && item.StoreNo.$ ? String(item.StoreNo.$) : null,
					url: item.StoreUrl && item.StoreUrl.$ ? item.StoreUrl.$ : null
				});
			}
		}
		return stores;
	}

	/**
	 * Returns location.
	 *
	 * @param item Store item.
	 * @returns Parsed data.
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	private getLocation(item: any): IStoreLocation | null {
		if (item.StoreLocation && item.StoreLocation.Latitude && item.StoreLocation.Latitude.$) {
			return {
				latitude: item.StoreLocation.Latitude.$,
				longitude: item.StoreLocation.Longitude.$
			};
		}
		return null;
	}
}
